export * from '@primeuix/themes/lara/progressbar';
export { default } from '@primeuix/themes/lara/progressbar';
